<template>
  <div class="auth-wrapper auth-v2">

    <!-- modal scrolling content -->
    <b-modal id="modal-tall" title="Contrat d'utilisation de CBP" cancel-variant="outline-secondary"
      cancel-title="Annuler" ok-title="J'accepte" @ok="acceptContractButtonClick">
      <b-card-text>
        <iframe style="width:100%; height: 100%" src="/contract.html" title="Contrat d'utilisation de CBP"></iframe>
      </b-card-text>
    </b-modal>

    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img :src="require('@/assets/images/logo/logo128pxCarre.png')" width="80" alt="logo" />
        <!--  <h2 class="brand-text text-primary ml-1">
          {{ appName }}
        </h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <!-- <b-img
            fluid
            :src="imgUrl"
            style="max-width: 400px"
            alt="Inscription"
          /> -->
          <svg xmlns="http://www.w3.org/2000/svg" width="650" height="550" viewBox="0 0 650 550" fill="none">
            <g opacity="0.4">
              <path opacity="0.4"
                d="M38.6766 106.363C44.5732 106.363 49.3532 101.581 49.3532 95.6817C49.3532 89.7823 44.5732 85 38.6766 85C32.7801 85 28 89.7823 28 95.6817C28 101.581 32.7801 106.363 38.6766 106.363Z"
                fill="#262F63"></path>
              <path
                d="M42.6302 96.9639C42.3818 96.5214 42.0414 96.1461 41.6353 95.8669C41.2399 95.5945 40.8103 95.3834 40.3594 95.24C40.1106 95.1576 39.8097 95.0726 39.4665 94.9744C39.1904 94.892 38.8894 94.815 38.4243 94.7087C37.9423 94.6 37.4691 94.4508 37.0091 94.2625C36.7844 94.1645 36.5855 94.0095 36.4296 93.8109C36.3021 93.6335 36.2393 93.4126 36.253 93.1894C36.253 93.1548 36.253 93.1229 36.253 93.0884C36.2628 92.9001 36.3242 92.7191 36.4296 92.5678C36.6164 92.3254 36.8615 92.1417 37.1385 92.0365C37.5946 91.8721 38.0751 91.7983 38.5562 91.8187C38.929 91.8188 39.3002 91.8706 39.6605 91.9728C39.8992 92.0451 40.124 92.162 40.3245 92.3181C40.4519 92.4158 40.5607 92.5384 40.6454 92.6794L41.1851 93.5719L42.859 92.4217L42.3193 91.5292C42.1008 91.1646 41.8198 90.8473 41.491 90.5942C41.1034 90.2929 40.6689 90.0672 40.2076 89.9275C40.0283 89.8733 39.8465 89.829 39.6629 89.7947V87.5687H37.6732V89.7495C37.2747 89.8033 36.8823 89.8994 36.5017 90.0364C35.8804 90.2647 35.3292 90.6697 34.9075 91.2078L34.8801 91.2423C34.4971 91.7619 34.2793 92.3983 34.2583 93.0592C34.2168 93.7872 34.4206 94.5071 34.8328 95.0886L34.8652 95.1337C35.2463 95.6312 35.7416 96.0146 36.3028 96.2467C36.8592 96.4715 37.4314 96.6491 38.0139 96.7779C38.4393 96.8789 38.7104 96.9479 38.9541 97.0223H38.9815C39.2973 97.1073 39.5635 97.1844 39.7948 97.2587C40.0644 97.3437 40.3215 97.4689 40.5583 97.6306C40.6997 97.7309 40.8187 97.8633 40.9065 98.0184C40.9965 98.2092 41.0393 98.4213 41.0309 98.6347C41.0309 98.6506 41.0309 98.6665 41.0309 98.6825C41.0394 98.9404 40.9706 99.1944 40.8344 99.4076C40.6367 99.702 40.3613 99.9267 40.0435 100.053C39.5607 100.251 39.0453 100.341 38.5288 100.319H38.4666C37.9064 100.337 37.3503 100.211 36.845 99.9522C36.5951 99.808 36.3811 99.6022 36.2207 99.3519L35.6536 98.4779L34.0195 99.6892L34.5866 100.563C34.9327 101.099 35.3942 101.538 35.9322 101.843L35.9595 101.857C36.4994 102.136 37.0782 102.32 37.6732 102.401V104.569H39.6629V102.353C40.0409 102.283 40.4109 102.171 40.7673 102.019C41.4382 101.746 42.0205 101.27 42.4436 100.651C42.7809 100.116 42.9777 99.4941 43.0136 98.8503C43.0494 98.2066 42.923 97.5643 42.6476 96.9904L42.6302 96.9639Z"
                fill="white"></path>
              <path opacity="0.4"
                d="M328.506 58.0271C337.07 58.0271 344.012 51.0815 344.012 42.5136C344.012 33.9457 337.07 27 328.506 27C319.942 27 313 33.9457 313 42.5136C313 51.0815 319.942 58.0271 328.506 58.0271Z"
                fill="url(#paint0_linear)"></path>
              <path
                d="M335.12 43.8629C334.734 43.1602 334.204 42.564 333.572 42.1206C332.957 41.688 332.289 41.3528 331.588 41.125C331.201 40.9942 330.733 40.8592 330.199 40.7031C329.769 40.5723 329.301 40.45 328.577 40.2812C327.828 40.1086 327.092 39.8716 326.376 39.5725C326.027 39.4169 325.717 39.1707 325.475 38.8553C325.276 38.5735 325.179 38.2226 325.2 37.8681C325.2 37.8133 325.2 37.7626 325.2 37.7078C325.215 37.4088 325.311 37.1212 325.475 36.8809C325.765 36.4959 326.146 36.2042 326.577 36.0372C327.287 35.776 328.034 35.6587 328.783 35.6912C329.362 35.6913 329.94 35.7735 330.5 35.9359C330.872 36.0507 331.221 36.2364 331.533 36.4843C331.731 36.6396 331.901 36.8343 332.032 37.0581L332.872 38.4756L335.476 36.6489L334.636 35.2314C334.296 34.6523 333.859 34.1484 333.348 33.7464C332.745 33.2679 332.069 32.9094 331.352 32.6875C331.073 32.6015 330.79 32.5311 330.504 32.4765V28.9412H327.409V32.4048C326.789 32.4902 326.179 32.6428 325.587 32.8604C324.62 33.223 323.763 33.8663 323.107 34.7209L323.064 34.7758C322.469 35.6009 322.13 36.6118 322.097 37.6614C322.032 38.8176 322.349 39.9609 322.991 40.8845L323.041 40.9562C323.634 41.7463 324.404 42.3553 325.277 42.7239C326.143 43.0809 327.033 43.363 327.939 43.5676C328.601 43.7279 329.022 43.8376 329.402 43.9558H329.444C329.935 44.0908 330.349 44.2131 330.709 44.3312C331.129 44.4661 331.529 44.665 331.897 44.9218C332.117 45.0811 332.302 45.2915 332.439 45.5378C332.579 45.8407 332.645 46.1776 332.632 46.5165C332.632 46.5418 332.632 46.5672 332.632 46.5925C332.645 47.0021 332.538 47.4056 332.327 47.7442C332.019 48.2117 331.591 48.5686 331.096 48.7693C330.345 49.0829 329.544 49.2265 328.74 49.1912H328.643C327.772 49.2201 326.907 49.0204 326.121 48.609C325.732 48.3801 325.399 48.0532 325.15 47.6556L324.267 46.2676L321.726 48.1914L322.608 49.5793C323.146 50.43 323.864 51.1274 324.701 51.6128L324.743 51.6339C325.583 52.0775 326.483 52.3696 327.409 52.4987V55.9412H330.504V52.4228C331.092 52.3106 331.668 52.1325 332.222 51.8912C333.266 51.4574 334.172 50.7026 334.83 49.7186C335.354 48.869 335.661 47.8815 335.716 46.8591C335.772 45.8366 335.576 44.8166 335.147 43.9051L335.12 43.8629Z"
                fill="white"></path>
              <path opacity="0.4"
                d="M585.492 339.013C602.332 339.013 615.984 325.355 615.984 308.506C615.984 291.658 602.332 278 585.492 278C568.652 278 555 291.658 555 308.506C555 325.355 568.652 339.013 585.492 339.013Z"
                fill="url(#paint1_linear)"></path>
              <path
                d="M597.918 312.08C597.229 310.805 596.283 309.723 595.155 308.918C594.057 308.133 592.863 307.525 591.611 307.111C590.92 306.874 590.084 306.629 589.13 306.346C588.363 306.108 587.528 305.886 586.236 305.58C584.897 305.267 583.582 304.837 582.304 304.294C581.68 304.011 581.128 303.565 580.695 302.992C580.34 302.481 580.166 301.844 580.204 301.201C580.204 301.101 580.204 301.009 580.204 300.91C580.231 300.367 580.402 299.845 580.695 299.409C581.214 298.71 581.894 298.181 582.664 297.878C583.931 297.404 585.265 297.191 586.602 297.25C587.637 297.25 588.668 297.399 589.669 297.694C590.332 297.902 590.957 298.239 591.514 298.689C591.868 298.971 592.17 299.324 592.405 299.731L593.904 302.303L598.554 298.988L597.055 296.415C596.448 295.364 595.667 294.45 594.754 293.72C593.677 292.852 592.47 292.202 591.189 291.799C590.691 291.643 590.186 291.515 589.676 291.416V285H584.149V291.286C583.042 291.441 581.952 291.718 580.895 292.113C579.169 292.771 577.638 293.938 576.466 295.489L576.39 295.589C575.327 297.086 574.722 298.921 574.663 300.825C574.548 302.924 575.114 304.999 576.259 306.675L576.349 306.805C577.408 308.239 578.783 309.344 580.342 310.013C581.888 310.661 583.477 311.173 585.096 311.544C586.277 311.835 587.03 312.034 587.707 312.249H587.783C588.661 312.494 589.4 312.716 590.042 312.93C590.791 313.175 591.505 313.536 592.163 314.002C592.556 314.291 592.886 314.673 593.131 315.12C593.38 315.669 593.499 316.281 593.476 316.896C593.476 316.942 593.476 316.988 593.476 317.034C593.5 317.777 593.308 318.509 592.93 319.124C592.381 319.972 591.616 320.62 590.733 320.984C589.392 321.553 587.961 321.814 586.526 321.75H586.353C584.797 321.802 583.252 321.44 581.848 320.693C581.154 320.278 580.56 319.685 580.114 318.963L578.539 316.444L574 319.935L575.575 322.454C576.537 323.998 577.818 325.264 579.313 326.145L579.389 326.183C580.889 326.988 582.496 327.518 584.149 327.752V334H589.676V327.615C590.726 327.411 591.754 327.088 592.744 326.65C594.607 325.863 596.225 324.493 597.4 322.707C598.337 321.165 598.884 319.373 598.983 317.518C599.083 315.662 598.732 313.811 597.967 312.157L597.918 312.08Z"
                fill="white"></path>
              <path
                d="M392.104 108.663C393.494 108.663 394.884 108.663 396.275 108.663C398.804 108.663 401.333 108.663 403.862 108.663C405.078 108.663 406.294 108.663 407.51 108.663C408.717 108.663 409.725 107.655 409.725 106.448C409.725 105.24 408.717 104.232 407.51 104.232C406.12 104.232 404.729 104.232 403.339 104.232C400.81 104.232 398.281 104.232 395.752 104.232C394.536 104.232 393.32 104.232 392.104 104.232C390.896 104.232 389.889 105.24 389.889 106.448C389.889 107.655 390.896 108.663 392.104 108.663Z"
                fill="#E0E7FC"></path>
            </g>
            <rect x="64" y="49" width="521" height="285" rx="4" fill="#262F63"></rect>
            <rect x="68" y="54" width="513" height="274" fill="url(#paint2_linear)"></rect>
            <line x1="110.5" y1="93" x2="110.5" y2="295" stroke="#262F63"></line>
            <line x1="533" y1="295.5" x2="111" y2="295.5" stroke="#262F63"></line>
            <path
              d="M313.428 509.317C464.23 526.489 606.361 509.317 609 472.153C609 457.709 483.757 446 329.262 446C174.767 446 45 457.709 45 472.153C45 486.596 184.492 494.634 313.428 509.317Z"
              fill="#262F63"></path>
            <path d="M131.543 219.104L221.258 270.863L395.512 141.466L440.369 169.071L505.93 112.137" stroke="#5982BE"
              stroke-width="6"></path>
            <circle cx="218.052" cy="268.925" r="6.33798" fill="#5B84C0"></circle>
            <circle cx="394.032" cy="140.394" r="6.33798" fill="#262F63"></circle>
            <circle cx="438.89" cy="167.997" r="6.33798" fill="#262F63"></circle>
            <circle cx="507.899" cy="109.338" r="6.33798" fill="#262F63"></circle>
            <circle cx="128.338" cy="217.165" r="6.33798" fill="#262F63"></circle>
            <rect x="57.4805" y="386.341" width="10.3078" height="71.693" stroke="white"></rect>
            <rect x="75.2495" y="413.804" width="10.3078" height="44.2312" stroke="white"></rect>
            <rect x="93.019" y="375.034" width="10.3078" height="83.0008" stroke="white"></rect>
            <rect x="110.788" y="357.265" width="10.3078" height="100.77" stroke="white"></rect>
            <path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd"
              d="M581.994 114.143C580.244 114.334 578.467 114.431 576.667 114.431C549.789 114.431 528 92.6422 528 65.7641C528 59.873 529.047 54.2263 530.964 49H563.004C573.492 49 581.994 57.5019 581.994 67.9896V114.143Z"
              fill="#2D26CF"></path>
            <path
              d="M577.699 104.445C605.147 104.445 627.398 82.1832 627.398 54.7223C627.398 27.2615 605.147 5 577.699 5C550.251 5 528 27.2615 528 54.7223C528 82.1832 550.251 104.445 577.699 104.445Z"
              fill="white"></path>
            <path
              d="M637.055 55.0707C637.055 81.3108 615.784 102.583 589.544 102.583C563.303 102.583 542.032 81.3108 542.032 55.0707C542.032 28.8306 563.303 7.55878 589.544 7.55878C615.784 7.55878 637.055 28.8306 637.055 55.0707Z"
              stroke="white" stroke-width="1.22254"></path>
            <path
              d="M567.665 83.1773C566.267 83.1793 564.912 82.6916 563.836 81.7988L549.584 69.9922C547.903 68.631 547.083 66.4711 547.436 64.3365C547.789 62.2019 549.262 60.4219 551.292 59.6756C553.322 58.9293 555.596 59.3319 557.247 60.7297L567.027 68.8313L597.596 34.3449C599.798 31.8606 603.597 31.6332 606.08 33.8371C608.563 36.0409 608.791 39.8413 606.588 42.3256L572.166 81.1555C571.026 82.445 569.386 83.1815 567.665 83.1773Z"
              fill="#71BEB5"></path>
            <path
              d="M353.282 459.365C353.282 459.365 338.562 465.57 305.472 468.18C287.358 469.592 263.732 469.914 234 467.529C149.961 474.277 114.718 459.365 114.718 459.365C49.5359 392.806 125.582 250.198 152.741 216.231C165.296 200.54 183.641 194.134 199.748 191.773C211.107 190.145 222.639 190.134 234 191.743C245.363 190.134 256.897 190.144 268.258 191.773C276.822 193.027 286.025 195.424 294.645 199.768C302.63 203.69 309.663 209.309 315.253 216.231C342.418 250.198 418.464 392.806 353.282 459.365Z"
              fill="url(#paint3_linear)"></path>
            <path
              d="M298.731 107.684C298.731 107.684 291.986 75.4037 236.184 103.464C180.382 131.524 286.093 125.169 286.093 125.169C286.093 125.169 299.418 117.108 298.731 107.684Z"
              fill="#4FA39A"></path>
            <path
              d="M189.518 158.435C189.518 158.435 152.106 117.049 172.522 98.6867C188.537 84.2988 234.892 102.947 254.15 111.632C262.451 115.426 271.466 117.409 280.595 117.451C289.568 117.451 298.585 115.667 298.755 108.534C298.755 108.534 299.365 140.055 276.096 158.441C252.827 176.828 189.518 158.435 189.518 158.435Z"
              fill="url(#paint4_linear)"></path>
            <path
              d="M232.592 165.394C232.592 165.394 260.595 155.892 269.194 137.049C269.194 137.049 268.849 155.205 255.436 162.399C242.023 169.592 232.592 165.394 232.592 165.394Z"
              fill="#4FA39A"></path>
            <path
              d="M276.635 158.165H189.958C185.515 158.165 181.913 161.676 181.913 166.007V167.215C181.913 171.547 185.515 175.058 189.958 175.058H276.635C281.078 175.058 284.68 171.547 284.68 167.215V166.007C284.68 161.676 281.078 158.165 276.635 158.165Z"
              fill="#262F63"></path>
            <path
              d="M162.204 448.165C162.204 448.165 237.928 489.342 305.796 448.165C305.796 448.165 234.552 460.587 162.204 448.165Z"
              fill="#4FA39A"></path>
            <path
              d="M190.358 125.787C190.358 125.787 195.425 153.95 215.698 158.165C215.698 158.165 193.403 138.269 190.358 125.787Z"
              fill="#4FA39A"></path>
            <path
              d="M127.974 329.913C127.974 329.913 118.658 385.571 157.982 400.301C157.982 400.301 125.903 360.327 127.974 329.913Z"
              fill="#4FA39A"></path>
            <path opacity="0.34"
              d="M227.666 339.767C255.267 339.767 277.642 317.392 277.642 289.791C277.642 262.19 255.267 239.815 227.666 239.815C200.065 239.815 177.69 262.19 177.69 289.791C177.69 317.392 200.065 339.767 227.666 339.767Z"
              fill="#0A0A0A"></path>
            <path
              d="M276.639 175.058H189.955C185.513 175.058 181.913 178.524 181.913 182.801C181.913 187.077 185.513 190.543 189.955 190.543H276.639C281.08 190.543 284.68 187.077 284.68 182.801C284.68 178.524 281.08 175.058 276.639 175.058Z"
              fill="#262F63"></path>
            <path
              d="M233.999 334.136C261.989 334.136 284.679 311.446 284.679 283.456C284.679 255.467 261.989 232.777 233.999 232.777C206.01 232.777 183.32 255.467 183.32 283.456C183.32 311.446 206.01 334.136 233.999 334.136Z"
              fill="#EBF2FC"></path>
            <path
              d="M248.572 284.475C247.662 282.758 246.414 281.3 244.924 280.216C243.475 279.159 241.899 278.339 240.246 277.783C239.334 277.463 238.231 277.133 236.972 276.751C235.96 276.432 234.856 276.133 233.151 275.72C231.384 275.298 229.648 274.719 227.962 273.988C227.138 273.607 226.409 273.005 225.837 272.234C225.369 271.545 225.139 270.688 225.189 269.821C225.189 269.687 225.189 269.563 225.189 269.429C225.225 268.698 225.451 267.996 225.837 267.408C226.522 266.467 227.42 265.754 228.436 265.346C230.109 264.707 231.87 264.421 233.634 264.5C235.001 264.5 236.362 264.701 237.683 265.098C238.559 265.379 239.383 265.833 240.118 266.439C240.585 266.818 240.984 267.294 241.295 267.841C242.351 269.69 244.779 270.211 246.5 268.959L246.68 268.828C248.235 267.697 248.69 265.577 247.736 263.907L247.432 263.376C246.631 261.96 245.601 260.729 244.395 259.746C242.974 258.576 241.381 257.7 239.69 257.157C239.032 256.947 238.366 256.775 237.693 256.642V251.648C237.693 249.633 236.059 248 234.045 248C232.03 248 230.397 249.633 230.397 251.648V256.467C228.936 256.675 227.497 257.048 226.101 257.58C223.823 258.467 221.802 260.039 220.256 262.128L220.155 262.262C218.751 264.279 217.953 266.75 217.875 269.316C217.723 272.142 218.471 274.937 219.982 277.195L220.101 277.37C221.498 279.301 223.314 280.79 225.372 281.691C227.412 282.564 229.51 283.253 231.646 283.753C233.206 284.145 234.2 284.413 235.093 284.702H235.194C236.352 285.032 237.328 285.331 238.176 285.62C239.165 285.95 240.107 286.436 240.976 287.064C241.494 287.453 241.93 287.967 242.252 288.569C242.582 289.31 242.739 290.133 242.708 290.962C242.708 291.024 242.708 291.086 242.708 291.147C242.74 292.149 242.487 293.135 241.988 293.963C241.263 295.106 240.253 295.978 239.088 296.469C237.318 297.235 235.428 297.586 233.534 297.5H233.306C231.252 297.571 229.213 297.082 227.36 296.077C226.444 295.517 225.659 294.718 225.071 293.746C223.964 291.939 221.528 291.502 219.861 292.81L219.65 292.976C218.14 294.162 217.757 296.291 218.76 297.928L219.079 298.449C220.348 300.528 222.04 302.233 224.013 303.419L224.113 303.471C226.093 304.555 228.215 305.269 230.397 305.585V310.352C230.397 312.367 232.03 314 234.045 314C236.059 314 237.693 312.367 237.693 310.352V305.399C239.078 305.125 240.435 304.69 241.742 304.1C244.202 303.039 246.337 301.195 247.888 298.789C249.125 296.712 249.847 294.299 249.978 291.799C250.11 289.3 249.646 286.806 248.636 284.578L248.572 284.475Z"
              fill="#262F63"></path>
            <rect x="339" y="416" width="89" height="15" rx="3" fill="url(#paint5_linear)"></rect>
            <rect x="455" y="416" width="89" height="15" rx="3" fill="url(#paint6_linear)"></rect>
            <rect x="442" y="386" width="89" height="15" rx="3" fill="url(#paint7_linear)"></rect>
            <rect x="334" y="431" width="89" height="15" rx="3" fill="url(#paint8_linear)"></rect>
            <rect x="450" y="431" width="89" height="15" rx="3" fill="url(#paint9_linear)"></rect>
            <rect x="437" y="401" width="89" height="15" rx="3" fill="url(#paint10_linear)"></rect>
            <rect x="339" y="446" width="89" height="15" rx="3" fill="url(#paint11_linear)"></rect>
            <rect x="455" y="446" width="89" height="15" rx="3" fill="url(#paint12_linear)"></rect>
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M546.587 331.749L475.91 362.722L479.514 370.947L479.515 370.947C479.516 370.948 479.516 370.948 479.516 370.949C481.065 374.482 498.142 370.413 517.659 361.86C537.176 353.307 551.742 343.509 550.194 339.976C550.186 339.958 550.178 339.941 550.169 339.924L546.587 331.749Z"
              fill="#E8A341"></path>
            <ellipse cx="511.253" cy="347.236" rx="38.5831" ry="6.98487" transform="rotate(-23.6645 511.253 347.236)"
              fill="#F3BF75"></ellipse>
            <ellipse cx="511.252" cy="347.235" rx="33.2613" ry="5.98703" transform="rotate(-23.6645 511.252 347.235)"
              fill="#E8A341"></ellipse>
            <ellipse cx="511.657" cy="348.15" rx="31.9309" ry="4.9892" transform="rotate(-23.6645 511.657 348.15)"
              fill="#F3BF75"></ellipse>
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M496.062 348.483L431.858 305.676L426.876 313.148L426.876 313.148C426.876 313.148 426.876 313.149 426.875 313.149C424.735 316.359 437.373 328.544 455.102 340.365C472.831 352.186 488.939 359.167 491.079 355.957C491.084 355.949 491.09 355.94 491.096 355.932L496.062 348.483Z"
              fill="#E8A341"></path>
            <ellipse cx="463.963" cy="327.08" rx="38.5831" ry="6.98487" transform="rotate(33.6935 463.963 327.08)"
              fill="#F3BF75"></ellipse>
            <ellipse cx="463.964" cy="327.081" rx="33.2613" ry="5.98703" transform="rotate(33.6935 463.964 327.081)"
              fill="#E8A341"></ellipse>
            <ellipse cx="463.411" cy="327.912" rx="31.9309" ry="4.9892" transform="rotate(33.6935 463.411 327.912)"
              fill="#F3BF75"></ellipse>
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M458.106 264.654C457.898 264.518 457.714 264.36 457.553 264.177C453.94 260.074 463.779 245.507 479.529 231.642C495.207 217.839 510.831 209.935 514.537 213.91L514.638 213.82L523.173 223.477L466.115 273.625L458.04 264.713L458.106 264.654Z"
              fill="#F3BF75"></path>
            <ellipse cx="494.293" cy="248.291" rx="37.9936" ry="9.899" transform="rotate(-41.3598 494.293 248.291)"
              fill="#E8A341"></ellipse>
            <defs>
              <linearGradient id="paint0_linear" x1="313" y1="42.5136" x2="344.012" y2="42.5136"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#514975"></stop>
                <stop offset="0.98" stop-color="#6C6491"></stop>
              </linearGradient>
              <linearGradient id="paint1_linear" x1="555.006" y1="308.506" x2="615.984" y2="308.506"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#514975"></stop>
                <stop offset="0.98" stop-color="#6C6491"></stop>
              </linearGradient>
              <linearGradient id="paint2_linear" x1="325" y1="67" x2="324.5" y2="328" gradientUnits="userSpaceOnUse">
                <stop stop-color="#F3FAFC"></stop>
                <stop offset="1" stop-color="#DDE5FC"></stop>
              </linearGradient>
              <linearGradient id="paint3_linear" x1="233.798" y1="437.762" x2="233.798" y2="213.164"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#74C0B8"></stop>
                <stop offset="1" stop-color="#4EA399"></stop>
              </linearGradient>
              <linearGradient id="paint4_linear" x1="232.5" y1="158.334" x2="232.5" y2="99.3484"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#74C0B8"></stop>
                <stop offset="1" stop-color="#4EA399"></stop>
              </linearGradient>
              <linearGradient id="paint5_linear" x1="393.769" y1="433" x2="394.711" y2="415.373"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#E8A341"></stop>
                <stop offset="0.98" stop-color="#F3BF75"></stop>
              </linearGradient>
              <linearGradient id="paint6_linear" x1="509.769" y1="433" x2="510.711" y2="415.373"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#E8A341"></stop>
                <stop offset="0.98" stop-color="#F3BF75"></stop>
              </linearGradient>
              <linearGradient id="paint7_linear" x1="496.769" y1="403" x2="497.711" y2="385.373"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#E8A341"></stop>
                <stop offset="0.98" stop-color="#F3BF75"></stop>
              </linearGradient>
              <linearGradient id="paint8_linear" x1="388.769" y1="448" x2="389.711" y2="430.373"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#E8A341"></stop>
                <stop offset="0.98" stop-color="#F3BF75"></stop>
              </linearGradient>
              <linearGradient id="paint9_linear" x1="504.769" y1="448" x2="505.711" y2="430.373"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#E8A341"></stop>
                <stop offset="0.98" stop-color="#F3BF75"></stop>
              </linearGradient>
              <linearGradient id="paint10_linear" x1="491.769" y1="418" x2="492.711" y2="400.373"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#E8A341"></stop>
                <stop offset="0.98" stop-color="#F3BF75"></stop>
              </linearGradient>
              <linearGradient id="paint11_linear" x1="393.769" y1="463" x2="394.711" y2="445.373"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#E8A341"></stop>
                <stop offset="0.98" stop-color="#F3BF75"></stop>
              </linearGradient>
              <linearGradient id="paint12_linear" x1="509.769" y1="463" x2="510.711" y2="445.373"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#E8A341"></stop>
                <stop offset="0.98" stop-color="#F3BF75"></stop>
              </linearGradient>
            </defs>
          </svg>
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5 svg_background">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-text class="mb-2" style="margin-top: 40px">
            <p class="text-success">Inscrivez-vous et commencer</p>
          </b-card-text>

          <!-- <div class="alert alert-danger mt-4" v-if="errors.length">
              <ul class="mb-0">
                <li v-for="(errors, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
          </div> -->

          <!-- form -->
          <validation-observer ref="registerForm" #default="{ invalid }">
            <b-form class="auth-register-form mt-2" @submit.prevent="register" autocomplete="off">

              <!-- fullName -->
              <b-form-group label="Nom complet" label-for="fullName">
                <validation-provider #default="{ errors }" name="fullName" vid="fullName" rules="min:3|required">
                  <b-form-input id="fullName" v-model="fullName" name="fullName" :state="errors.length > 0 ? false : null"
                    placeholder="Ex: Julien M" autocomplete="off" />
                  <b-form-invalid-feedback>
                    Votre nom complet ici (min 3 lettres)
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group label="Email" label-for="register-email">
                <validation-provider #default="{ errors }" name="Email" vid="email" rules="required|email">
                  <b-form-input id="register-email" v-model="userEmail" name="register-email"
                    :state="errors.length > 0 ? false : null" placeholder="Ex: membre@cbpcommunity.com"
                    autocomplete="off" />
                  <b-form-invalid-feedback>
                    Compléter votre email ici
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>

              <!-- userPhone -->
              <b-form-group label="Téléphone" label-for="register-phone">
                <validation-provider #default="{ errors }" name="Téléphone" vid="phone" rules="min:8|required">
                  <cleave id="register-phone" v-model="userPhone" name="register-phone" :raw="false"
                    :options="options.prefix" :state="errors.length > 0 ? false : null" class="form-control"
                    autocomplete="off" />
                  <b-form-invalid-feedback>
                    Compléter votre n° de téléphone ici
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>

              <b-form-group label="Code de Parrainage" label-for="register-phone" v-if="sku_user_parent.length < 5">
                <validation-provider #default="{ errors }" name="Code Parrainage" vid="sku_user_parent"
                  rules="min:8|required">
                  <b-form-input id="sku_user_parent" v-model="sku_user_parent" name="sku_user_parent"
                    :state="errors.length > 0 ? false : null" placeholder="CBP-....." min="4" autocomplete="off" />
                  <b-form-invalid-feedback>
                    Compléter le code du parrain ici
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group label-for="register-password" label="Mot de passe">
                <validation-provider #default="{ errors }" name="Password" vid="password" rules="required">
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                    <b-form-input id="register-password" v-model="password" class="form-control-merge"
                      :type="passwordFieldType" :state="errors.length > 0 ? false : null" name="register-password"
                      placeholder="············" autocomplete="off" />
                    <b-input-group-append is-text>
                      <feather-icon :icon="passwordToggleIcon" class="cursor-pointer" @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <b-form-invalid-feedback>
                    Compléter votre mot de passe/pin ici
                  </b-form-invalid-feedback>
                </validation-provider>
              </b-form-group>

             <!--  <b-form-group label="Package à souscrire" label-for="role">
                <v-select id="role" v-model="role"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="packagesListOptions"
                    :reduce="(val) => val.value" trim :clearable="false" />
              </b-form-group>  -->

              <b-form-group>
                <validation-provider #default="{ errors }" name="accept_contrat" vid="accept_contrat" rules="required">
                  <b-form-checkbox id="accept_contrat" v-model="accept_contrat" name="accept_contrat"
                    :state="errors.length > 0 ? false : null">
                    J'accepte
                    <b-link v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-modal.modal-tall variant="outline-success"
                      class="text-success">le contrat d'utilisation </b-link>
                  </b-form-checkbox>
                  <small class="text-danger" v-if="accept_contrat == false">Svp, lisez tout tranquillement avant d'accépter!</small>

                </validation-provider>
              </b-form-group>

              <b-button variant="success" block type="submit" :disabled="loading">

                <LoadingIcon v-if="loading" style="width: 24px; float: center"></LoadingIcon>

                <span v-if="loading == false">S'inscrire</span>
                
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <span>Déjà inscrit?</span>
            <b-link :to="{ name: 'auth-login' }">
              <span>&nbsp;Se connecter</span>
            </b-link>
          </p>

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">ou</div>
          </div>

          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import LoadingIcon from "@core/layouts/components/Loading.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText,
  BFormInvalidFeedback,
  BModal,
  VBModal,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { initialAbility } from "@/libs/acl/config";
import useJwt from "@/auth/jwt/useJwt";
import axios from "axios";
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import { $themeConfig } from "@themeConfig";
import Ripple from 'vue-ripple-directive'
import vSelect from "vue-select";

export default {
  //name: 'AddContact',
  setup() {
    // App Name
    const { appName, appLogoImage, api_endpoint } = $themeConfig.app;
    return {
      appName,
      appLogoImage,
      api_endpoint,
      LoadingIcon,
    };
  },
  components: {
    // VuexyLogo,
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // validations
    ValidationProvider,
    ValidationObserver,
    // mask
    Cleave,
    BFormInvalidFeedback,
    LoadingIcon,
    vSelect
  },
  mixins: [togglePasswordVisibility],
  mounted() {
    //
    console.log($themeConfig.app.api_endpoint);
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      // ------------------------
      // form inputs //
      // ------------------------
      fullName: "",
      userEmail: "",
      userPhone: null,
      sku_user_parent: this.$route.params.referer,
      password: "",
      role: "",
      accept_contrat: false,
      // packagesListOptions: [],
      min_value: 10,
      sideImg: require("@/invest.svg"),
      loading: false,
      // validation
      required,
      email,
      errors: [],
      // formatter
      options: {
        phone: {
          phone: true,
          phoneRegionCode: 'US',
        },
        prefix: {
          prefix: '+',
          blocks: [1, 3, 3, 3, 3],
          uppercase: true,
        },
      },
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/register-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  async mounted() {
    var last_route_name = localStorage.getItem("last_route_name");
    if (
      last_route_name != "" &&
      last_route_name != null &&
      last_route_name != undefined
    ) {
      // s il ya de route en attente
      this.refreshSystemShow = true;
    }

    // recuperation des donnees
    if (localStorage.getItem("menus") == null) {
      // online get
      // get menus
      this.getMenus();
    } else {
      if (this.refreshSystem == true) {
        // refresh menu
        this.getMenus();
      } else {
        this.loading = false;
      }
    }

    // load requirement
    /* await myApi
      .get(`package`)
      .then((response) => {
        // default action
        var data = response.data.data;
        var i = 0;
        for (i = 0; i < data.length; i++) {
          var name = data[i].name;

          if (name.length > 15) {
            name = name.substring(0, 15);
          }

          this.packagesListOptions.push({
            label: "Nom: " + name + " | Montant: " + data[i].amount + "$",
            value: data[i].code
          });
        }
      })
      .catch((error) => {
        //
        console.log(error);
      });
 */
  },
  methods: {
    showToast(header, message, variant, icon, position, timeout) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: header,
            icon,
            text: message,
            variant,
          },
        },
        {
          position,
          timeout,
        }
      );
    },
    async getMenus(mode) {
      this.loading = true;
      localStorage.removeItem("menus");
      myApi({
        url: "get-all-menus",
        method: "get",
      })
        .then((response) => {
          localStorage.setItem("menus", JSON.stringify(response.data.data));
          // activate login button
          this.loading = false;
        })
        .catch((error) => {
          this.loading = true;
        });
    },
    acceptContractButtonClick(bvModalEvt) {
      // Prevent modal from closing
      // bvModalEvt.preventDefault()

      this.accept_contrat = true;
    },
    register() {

      this.loading = true;

      this.$refs.registerForm.validate().then((success) => {

        if (success) {

          let formData = new FormData();
          formData.append('sku_user_parent', this.sku_user_parent);
          formData.append('fullName', this.fullName);
          formData.append('email', this.userEmail);
          formData.append('phone', this.userPhone);
          formData.append('password', this.password);
          formData.append('accept_contrat', this.accept_contrat);

          axios({
            url: "auth/signup",
            method: "post",
            data: formData,
          })
            .then((response) => {

              this.loading = false;

              if(response.status == 200){

                // empty login cache
                localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
                localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);

                // Remove userData from localStorage
                localStorage.removeItem("userData");
                localStorage.removeItem("token");
                localStorage.removeItem("roles-permissions");

                // Reset ability
                this.$ability.update(initialAbility);

                // signup ok // backend login ok
                this.showToast(
                  "Bravo!!!, Inscription réussi.",
                  "Veuillez vous connecter avec votre email et mot de passe/pin",
                  "primary",
                  "CheckIcon",
                  "top-center",
                  2000
                );

                this.$router.push({ "path": "/" });

              }else{
                // signup ok // backend login ok
                this.showToast(
                  "Erreur Survenue",
                  response.data.message,
                  "warning",
                  "InfoIcon",
                  "top-center",
                  5000
                );
              } 

            })
            .catch(function(error) {
              this.loading = false;
              this.showToast(
                "Erreur Exceptionnelle Survenu",
                error.response.data.message,
                "warning",
                "RemoveIcon",
                "top-center",
                5000
              );
            });

        } else {
          this.loading = false;
        }

      });

    }
  }
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
.v-select {

  &.item-selector-title,
  &.subscription-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}
</style>

<style lang="css">
.svg_background {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.dev/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1018%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(255%2c 255%2c 255%2c 1)'%3e%3c/rect%3e%3cpath d='M1369 137L1368 -177' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M434 145L433 -54' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M17 238L16 448' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M270 326L269 697' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M713 449L712 766' stroke-width='6' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M1191 321L1190 634' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M557 195L556 476' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M164 494L163 135' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M656 255L655 454' stroke-width='6' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M616 195L615 -161' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M1099 271L1098 17' stroke-width='6' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M946 251L945 485' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M1310 429L1309 45' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M527 335L526 677' stroke-width='6' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M166 246L165 -83' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M1175 528L1174 695' stroke-width='6' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M151 322L150 526' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M153 214L152 395' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M808 57L807 -143' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M236 204L235 31' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M870 109L869 -262' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M186 78L185 316' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M1164 407L1163 699' stroke-width='6' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M967 28L966 180' stroke-width='6' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M1411 476L1410 191' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M638 197L637 495' stroke-width='6' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M1008 409L1007 743' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M672 38L671 -381' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M1301 365L1300 693' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M698 211L697 -147' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M1360 483L1359 276' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M753 505L752 693' stroke-width='10' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M627 352L626 154' stroke-width='6' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3cpath d='M179 89L178 325' stroke-width='6' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M605 394L604 594' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1019%26quot%3b)' stroke-linecap='round' class='Down'%3e%3c/path%3e%3cpath d='M840 359L839 666' stroke-width='8' stroke='url(%26quot%3b%23SvgjsLinearGradient1020%26quot%3b)' stroke-linecap='round' class='Up'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1018'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3clinearGradient x1='0%25' y1='0%25' x2='0%25' y2='100%25' id='SvgjsLinearGradient1019'%3e%3cstop stop-color='rgba(243%2c 251%2c 255%2c 0)' offset='0'%3e%3c/stop%3e%3cstop stop-color='rgba(243%2c 251%2c 255%2c 1)' offset='1'%3e%3c/stop%3e%3c/linearGradient%3e%3clinearGradient x1='0%25' y1='100%25' x2='0%25' y2='0%25' id='SvgjsLinearGradient1020'%3e%3cstop stop-color='rgba(243%2c 251%2c 255%2c 0)' offset='0'%3e%3c/stop%3e%3cstop stop-color='rgba(243%2c 251%2c 255%2c 1)' offset='1'%3e%3c/stop%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e");
}
</style>

